import React, { useContext, useEffect, useRef, useState } from 'react';
import Button from '../../NecttosComp/Button/Button';
import { Main } from '../../NecttosComp/Layout/Layout';
import { getKeys } from '../../NecttosComp/APICaller/ApiServices';
import { FirebaseContext } from '../../context/FirebaseContext';
import { useQuery } from 'react-query';
import { uploadPhotoToFirebase } from '../../NecttosComp/APICaller/APICaller';
import toast, { Toaster } from 'react-hot-toast';
import { getAxiosInstance } from '../../utils/axiosInstance';
import { getCollegeDetailsee } from '../Admission/RemoveAction';
import moment from 'moment';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { GrFormEdit } from 'react-icons/gr';
import { MdAddBox, MdDelete } from 'react-icons/md';
import Select from 'react-select';
import { v4 as uuid4 } from 'uuid';
import Input2 from '../../NecttosComp/Input/Input2';
import { useTheme } from '../../context/ThemeContext.js';
import { Switch } from '@mui/material';

function TCView2({ tcView, setTcView, userId, profile, setProfile, refetchList }) {
	const [tcSettingId, setTcSettingId] = useState('');
	const { collegeId, user } = useContext(FirebaseContext);
	const initialSections = [
		{ keyName: 'name', title: 'Name of the Student', longTitle: 'Full Name of the Student as per Admission Records', value: '', type: 'string', width: '200px' },
		{ keyName: 'dob', title: 'Date of Birth as per Admission Register', longTitle: 'Date of Birth as Recorded in Admission Register', value: '', type: 'date', width: '150px' },
		{ keyName: 'admisionNo', title: 'Admission No.', longTitle: 'Admission Number of the Student', value: '', type: 'string', width: '100px' },
		{ keyName: 'dateOfAdmission', title: 'Date of Admission', longTitle: 'Date when the Student was Admitted', value: '', type: 'date', width: '150px' },
		{ keyName: 'dateOfLeaving', title: 'Date of Leaving', longTitle: 'Date when the Student Left the Institution', value: '', type: 'date', width: '150px' },
		{ keyName: 'longName', title: 'Programme Studied', longTitle: 'List of Subjects Studied by the Student', value: '', type: 'array', width: '300px' },
		{ keyName: 'reasonForLeaving', title: 'Course Completed', longTitle: 'Reason for Leaving the Institution (e.g., Course Completed)', value: '', type: 'string', width: '250px' },
		{ keyName: 'promotedToHigherClass', title: 'Promoted to Higher Class', longTitle: 'Details of Promotion to a Higher Class', value: 'Vide the Certificate', type: 'string', width: '200px' },
		{ keyName: 'duesCleared', title: 'Dues Cleared', longTitle: 'Confirmation if Dues Have Been Cleared', value: 'Yes', type: 'string', width: '100px' },
		{ keyName: 'exam', title: 'Examination last appeared', longTitle: 'Name of the Last Examination the Student Appeared For', value: '', type: 'string', width: '200px' },
		{ keyName: 'appliedOn', title: 'Date of Apply for TC', longTitle: 'Date When the Student Applied for Transfer Certificate', value: '', type: 'date', width: '150px' },
		{ keyName: 'aprovedOn', title: 'Date of Issue of TC', longTitle: 'Date When the Transfer Certificate was Issued', value: '', type: 'date', width: '150px' },
		{ keyName: 'characterAndConduct', title: 'Character and Conduct', longTitle: "Remarks on the Student's Character and Conduct", value: 'Good', type: 'string', width: '100px' },
	];

	const [sections, setSections] = useState(initialSections);
	const { theme } = useTheme();

	const [logo, setLogo] = useState(null);
	const [seal, setSeal] = useState(null);
	const [addNew, setAddNew] = useState(false);
	const ref = useRef(null);
	const [signature, setSignature] = useState(null);
	const [signatureText, setSignatureText] = useState(`Principal's Signature`);
	const [signatureTextEdit, setSignatureTextEdit] = useState(false);
	const [tcNumberText, setTcNumberText] = useState(`TC Number`);
	const [tcNumberTextEdit, setTcNumberTextedit] = useState(false);
	const [headerLogo, setHeaderLogo] = useState(false);
	const [watermarkLogo, setWatermarkLogo] = useState(false);
	const [settings, setSettings] = useState(false);
	const [editingField, setEditingField] = useState(null);
	const [editedTitle, setEditedTitle] = useState('');
	const [addHeader, setAddHeader] = useState(false);
	const [addCfield, setAddCField] = useState(false);
	const [customFields, setCustomFields] = useState([]);
	const [customTcDateKey, setCustomTcDateKey] = useState('tcDate');
	const [copies, setCopies] = useState(true);

	const [selectedFields, setSelectedFields] = useState({});

	const allFieldKeys = initialSections?.map((field) => field.keyName);
	let initialSelectedFields = allFieldKeys?.reduce((acc, keyName) => ({ ...acc, [keyName]: true }), {});

	const [newSection, setNewSection] = useState({
		keyName: '',
		title: '',
		longTitle: '',
		type: 'string',
	});
	const [customStyles, setCustomStyles] = useState({
		padding: '16px',
		margin: '0px',
		marginTop: '16px',
		fontSize: '14px',
		lineHeight: '14px',
		paraLineHeight: '14px',
		color: 'red',
		headerLineHeight: '14px',
		gap: '4px',
		headerFontSize: '28px',
		titleFontSize: '20px',
		orientation: 'landscape',
		printWidth: '147mm',
		printHeight: '210mm',
		watermarkOpacity: '0.1',
		textColor: '#333',
		borderColor: '#ccc',
		signatureWidth: '100px',
		signatureHeight: '50px',
		paperSize: 'custom',
		sealWidth: '80px',
		sealHeight: '80px',
		width: '147mm',
		height: '200mm',
		left: '10px',
		top: '10px',
		logoSize: '20px',
		watermarkLeft: '30%',
		watermarkTop: '30%',
		watermarkSize: '100px',
		watermarkOpacity: '0.1',
		bodyFieldFontWeight: 'normal',
		bodyValueFontWeight: 'bold',
		tcNoFontSize: '20px',
		tcNoLineHeight: '14px',
		tcNoFontWeight: 'bold',
		tcDateFontSize: '20px',
		tcDateLineHeight: '14px',
		tcDateFontWeight: 'bold',
		fontFamily: 'sans-serif',
		tcPosition: 'top-left',
		tcDatePosition: 'top-right',
		principlePosition: 'bottom-right',
		tcDateFormat: 'DD/MM/YYYY',
		tcNoAdjustVertical: '-15px',
		tcNoAdjustHorizontal: '0px',
		tcDateAdjustVertical: '-15px',
		tcDateAdjustHorizontal: '0px',
		signatureTextVertical: '-15px',
		signatureTextHorizontal: '0px',
		tcBatchPosition: 'none',
		tcBatchSeperation: '/ ',
		stringType: 'normal',
		sealPosition: 'bottom-right',
		sealTop: '0px',
		sealLeft: '0px',
		signPosition: 'bottom-right',
		signTop: '0px',
		signLeft: '0px',
		sealSize: '80px',
		signSize: '80px',
		ccNeeded: false,
		pageBreak: false,
		bodyAjustWidth: '0px',
		marginRight: '0px',
		bodyAjustHorizontal: '0px',
		bodyAjustVertical: '0px',
	});
	const { data: college } = useQuery([`collegddeData`, collegeId, headerLogo, seal, signature], getCollegeDetailsee);

	// const { data: profile } = useQuery('getProfileDataTc2', getProfileData({ studentId: userId, collegeId }));

	const { data: fieldsData = [] } = useQuery('getKeys', getKeys());

	function toPascalCaseWithSpaces(str) {
		if (typeof str !== 'string') return '';
		if (!str) return '';
		return str
			.split(' ')
			.map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : ''))
			.join(' ');
	}

	const getDetails = async () => {
		try {
			const instance = await getAxiosInstance();
			const { data } = await instance.get('/college/action/getTcSettings', {
				params: { collegeId, tcSettings: 'tcSettings', tcSections: 'tcSections' },
			});
			return data;
		} catch (error) {
			console.error('Error in getDetails:', error);
			throw error;
		}
	};

	const { data, refetch, isFetched } = useQuery(['getTcSettings', collegeId], getDetails, {
		enabled: !!collegeId,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
	});

	const saveSettings = async () => {
		const instance = getAxiosInstance();
		try {
			const section = sections.map((item) => {
				const isChecked = item?.checked ?? !!selectedFields[item.keyName];
				const id = item._id || uuid4();
				return { ...item, checked: isChecked, _id: id };
			});

			const resp = await instance.post('/college/action/updateTcSettings', { _id: tcSettingId, collegeId, updatedBy: user._id, selectedFields, sections: section, customStyles, customHeaders, selectedDateFormat, signatureText, customFields, tcNumberText, customTcDateKey });
			toast.success('submitted succesfully');
			setSettings(false);
			refetch();
		} catch (error) {
			toast.error('not saved');
			console.error('Error uploading file:', error);
		}
	};

	const handleLogoUpload = async (e) => {
		const { name, value } = e.target;
		const files = e.target.files;
		const instance = await getAxiosInstance();
		if (e.target.files && e.target.files[0]) {
			const { url } = await uploadPhotoToFirebase(files[0], `college/${collegeId}/${name}.jpg`, (progress) => { });
			setLogo(url);
			const { data } = await instance.post('/college/action/updateTcLogo', { collegeId, name, url });
			toast.success('logo upload success');
		}
	};
	const handleSealUpload = async (e) => {
		const { name, value } = e.target;
		const files = e.target.files;
		const instance = await getAxiosInstance();
		if (e.target.files && e.target.files[0]) {
			const { url } = await uploadPhotoToFirebase(files[0], `college/${collegeId}/${name}.jpg`, (progress) => { });
			setSeal(url);
			setHeaderLogo(url);
			const { data } = await instance.post('/college/action/updateTcLogo', { collegeId, name, url });
			toast.success('seal upload success');
		}
	};
	const handleSignatureUpload = async (e) => {
		const { name, value } = e.target;
		const files = e.target.files;
		const instance = await getAxiosInstance();
		if (e.target.files && e.target.files[0]) {
			const { url } = await uploadPhotoToFirebase(files[0], `college/${collegeId}/${name}.jpg`, (progress) => { });
			setSignature(url);
			const { data } = await instance.post('/college/action/updateTcLogo', { collegeId, name, url });
			toast.success('signature upload success');
		}
	};

	useEffect(() => {
		if (data && isFetched) {
			if (data?.statusCode === 200) {
				setTcSettingId(data?.tcSettings?._id);
				if (data?.tcSettings?.selectedFields) {
					setSelectedFields(data?.tcSettings?.selectedFields);
				} else {
					setSelectedFields(initialSelectedFields);
				}
				if (data?.tcSettings?.sections) {
					setSections([
						...data.tcSettings?.sections.map((item) => {
							if (item._id) {
								return item;
							} else {
								return { ...item, _id: uuid4(), checked: [data?.tcSettings?.selectedFields[item?.keyName] ?? initialSelectedFields[item?.keyName]] };
							}
						}),
						...data?.tcSettings?.customFields?.map((item) => {
							if (item._id) {
								return item;
							} else {
								return { ...item, _id: uuid4() };
							}
						}),
					]);
				}

				if (data?.tcSettings?.customStyles) {
					setCustomStyles((prev) => {
						return { ...prev, ...data?.tcSettings?.customStyles };
					});
				}
				if (data?.tcSettings?.customHeaders) {
					setCustomHeaders(data?.tcSettings?.customHeaders);
				}
				if (data?.tcSettings?.selectedDateFormat) {
					setSelectedDateFormat(data?.tcSettings?.selectedDateFormat);
				}
				if (data?.tcSettings?.signatureText) {
					setSignatureText(data?.tcSettings?.signatureText);
				}
				if (data?.tcSettings?.tcNumberText) {
					setTcNumberText(data?.tcSettings?.tcNumberText);
				}
				if (data?.tcSettings?.customFields) {
					setCustomFields([]);
					// setCustomFields(data?.tcSettings?.customFields);
				}
				if (data?.tcSettings?.customTcDateKey) {
					setCustomTcDateKey(data?.tcSettings?.customTcDateKey);
				}
			} else {
				throw new Error(data?.message || 'Failed to fetch tieDetails details.');
			}
		}
	}, [data]);

	useEffect(() => {
		if (college?.headerLogo) {
			setLogo(college.headerLogo);
			setHeaderLogo(college.headerLogo);
			setWatermarkLogo(college.headerLogo);

			setCustomHeaders((prev) =>
				prev.map((header) => {
					if (header.key === 'collegeName' && header.value === null) {
						return { ...header, value: college.collegeName };
					}
					if (header.key === 'affiliated' && header.value === null) {
						return { ...header, value: college.affiliated };
					}
					if (header.key === 'address' && header.value === null) {
						return { ...header, value: college.address };
					}
					return header;
				}),
			);
		}

		if (college?.seal) {
			setSeal(college.seal);
		}

		if (college?.signature) {
			setSignature(college.signature);
		}
	}, [college]);

	const handleFieldChange = (event) => {
		const { name, checked } = event.target;
		setSelectedFields((prevFields) => ({
			...prevFields,
			[name]: checked,
		}));
	};

	const handleTitleEdit = (field) => {
		setEditingField(field?.keyName);
		setEditedTitle(field?.title);
	};

	const handleDragEnd = (result) => {
		if (!result.destination) return;
		const { source, destination } = result;
		const updatedFields = Array.from(sections);
		const [movedItem] = updatedFields.splice(source.index, 1);
		updatedFields.splice(destination.index, 0, movedItem);
		setSections(updatedFields);
	};

	const headerStylesKeys = [
		{
			key: 'fontSize',
			type: 'number',
		},
		{
			key: 'lineHeight',
			type: 'number',
		},
		{
			key: 'fontWeight',
			type: 'string',
		},
		{
			key: 'textDecoration',
			type: 'string',
		},
		{
			key: 'color',
			type: 'string',
		},
	];

	const customHeadersData = [
		{
			key: 'collegeName',
			value: null,
			style: [
				{ key: 'fontSize', value: 24, title: 'CollegeName Font Size', type: 'string' },
				{ key: 'lineHeight', value: 14, title: 'Line Height', type: 'string' },
				{ key: 'fontWeight', value: 'normal', title: 'Font Weight', type: 'string' },
				{ key: 'textDecoration', value: 'none', title: 'Underline', type: 'string' },
				{ key: 'color', value: 'none', title: 'Color', type: 'string' },
			],
			checked: true,
		},
		{
			key: 'affiliated',
			value: null,
			style: [
				{ key: 'fontSize', value: 14, title: 'Affiliated Font Size', type: 'string' },
				{ key: 'lineHeight', value: 14, title: 'Line Height', type: 'string' },
				{ key: 'fontWeight', value: 'normal', title: 'Font Weight', type: 'string' },
				{ key: 'textDecoration', value: 'none', title: 'Underline', type: 'string' },
				{ key: 'color', value: 'black', title: 'Color', type: 'string' },
			],
			checked: true,
		},
		{
			key: 'address',
			value: null,
			style: [
				{ key: 'fontSize', value: 14, title: 'Address Font Size', type: 'string' },
				{ key: 'lineHeight', value: 14, title: 'Line Height', type: 'string' },
				{ key: 'fontWeight', value: 'normal', title: 'Font Weight', type: 'string' },
				{ key: 'textDecoration', value: 'none', title: 'Underline', type: 'string' },
				{ key: 'color', value: 'black', title: 'Color', type: 'string' },
			],
			checked: true,
		},
		{
			key: 'transferCertificate',
			value: 'TRANSFER CERTIFICATE',
			style: [
				{ key: 'fontSize', value: 14, title: 'TC Font Size', type: 'string' },
				{ key: 'lineHeight', value: 14, title: 'Line Height', type: 'string' },
				{ key: 'fontWeight', value: 'normal', title: 'Font Weight', type: 'string' },
				{ key: 'textDecoration', value: 'underline', title: 'Underline', type: 'string' },
				{ key: 'color', value: 'black', title: 'Color', type: 'string' },
			],
			checked: true,
		},
	];

	const [customHeaders, setCustomHeaders] = useState(customHeadersData);

	const handleStyleChange = (headerKey, styleKey, newValue) => {
		setCustomHeaders((prevHeaders) =>
			prevHeaders.map((header) =>
				header.key === headerKey
					? {
						...header,
						style: header.style.map((st) => (st.key === styleKey ? { ...st, value: newValue } : st)),
					}
					: header,
			),
		);
	};

	const [editingKey, setEditingKey] = useState(null);
	const [editedValue, setEditedValue] = useState('');
	const [newHeaderTitle, setNewHeaderTitle] = useState('');
	const [editingFieldKey, setEditingFieldKey] = useState(null);
	const handleEdit = (key, currentValue) => {
		setEditingKey(key);
		setEditedValue(currentValue);
	};

	const handleDragEndHeader = (result) => {
		if (!result.destination) return;

		const reorderedHeaders = Array.from(customHeaders);
		const [removed] = reorderedHeaders.splice(result.source.index, 1);
		reorderedHeaders.splice(result.destination.index, 0, removed);

		setCustomHeaders(reorderedHeaders);
	};

	const addNewHeader = () => {
		if (newHeaderTitle.trim() === '') return;

		const newHeader = {
			key: `header${Date.now()}}`,
			value: newHeaderTitle,
			checked: false,
			style: [
				{ key: 'fontSize', value: 16, title: 'Font Size', type: 'number' },
				{ key: 'lineHeight', value: 12, title: 'Line Height', type: 'number' },
				{ key: 'fontWeight', value: 'normal', title: 'Font Weight', type: 'string' },
				{ key: 'textDecoration', value: 'normal', title: 'Underline', type: 'string' },
				{ key: 'color', value: 'black', title: 'Color', type: 'string' },
			],
		};

		setCustomHeaders((prevHeaders) => [...prevHeaders, newHeader]);
		setNewHeaderTitle('');
		setAddHeader(false);
	};

	const [newCustomField, setNewCustomField] = useState({});

	const deleteHeaders = (header) => {
		setCustomHeaders((prvHeaders) => prvHeaders.filter((x) => x.key !== header));
	};
	const deleteSections = (section) => {
		setSections((prv) => prv.filter((x) => x._id !== section._id || x.keyName !== section.keyName));
	};

	const [selectedDateFormat, setSelectedDateFormat] = useState('DD/MM/YYYY');
	const [currentDate] = useState(new Date());

	const dateFormats = ['IN WORDS', 'DD/MM/YYYY', 'DD-MM-YYYY', 'DD.MM.YYYY', 'Do MMMM YYYY', 'Do MMM YYYY', 'DD MMM YYYY', 'DD/MM/YY', 'D/M/YY', 'D-M-YY', 'D.M.YY', 'DD-MM-YY', 'DD.MM.YY', 'MM/DD/YYYY', 'MM/DD/YY', 'YYYY-MM-DD', 'dddd, MMMM Do YYYY', 'DD-MM-YYYY HH:mm:ss', 'DD MMMM YYYY', 'D MMM YYYY, h:mm A', 'D MMM YYYY, HH:mm'];

	const handleChange = (e) => {
		setSelectedDateFormat(e.target.value);
	};

	const dayWords = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'Ninth', 'Tenth', 'Eleventh', 'Twelfth', 'Thirteenth', 'Fourteenth', 'Fifteenth', 'Sixteenth', 'Seventeenth', 'Eighteenth', 'Nineteenth', 'Twentieth', 'Twenty-first', 'Twenty-second', 'Twenty-third', 'Twenty-fourth', 'Twenty-fifth', 'Twenty-sixth', 'Twenty-seventh', 'Twenty-eighth', 'Twenty-ninth', 'Thirtieth', 'Thirty-first'];

	const monthWords = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

	function numberToWords(num) {
		const smallNumbers = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
		const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

		if (num < 20) return smallNumbers[num];
		if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + smallNumbers[num % 10] : '');
		if (num < 1000) {
			return smallNumbers[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + numberToWords(num % 100) : '');
		}
		if (num < 10000) {
			return smallNumbers[Math.floor(num / 1000)] + ' Thousand' + (num % 1000 ? ' ' + numberToWords(num % 1000) : '');
		}
		return '';
	}

	function dateToWords(dateObj) {
		const day = dateObj.getDate();
		const month = dateObj.getMonth();
		const year = dateObj.getFullYear();

		const dayWord = dayWords[day - 1];
		const monthWord = monthWords[month];
		const yearWord = numberToWords(year);

		return `${dayWord} ${monthWord} ${yearWord}`;
	}

	const formatCurrentDate = (rawDate, format) => {
		const date = new Date(rawDate);
		if (format === 'IN WORDS') {
			const dateObj = new Date(date);

			return dateToWords(dateObj);
		}
		if (date === null || date === undefined) return '';
		if (date === '') return '';

		if (typeof date === 'number') {
			date = date.toString();
		}
		if (!moment(date, moment.ISO_8601, true).isValid()) {
			return 'Invalid Date';
		}
		if (typeof format !== 'string') {
			return 'Invalid Format';
		}
		return moment(date).format(format);
	};

	function safeFieldRender(field, profile, selectedDateFormat, fallback = '—') {
		let value = profile?.[field?.keyName] ?? profile?.[field?.keyName?.slice(1)] ?? field?.value;

		if (value === null || value === undefined) return fallback;

		if (field?.stringType === 'upperCase') {
			if (typeof value === 'string') {
				value = value.toUpperCase();
			}
		} else if (field?.stringType === 'lowerCase') {
			if (typeof value === 'string') {
				value = value.toLowerCase();
			}
		} else if (field?.stringType === 'pascalCase') {
			if (typeof value === 'string') {
				value = toPascalCaseWithSpaces(value);
			}
		}

		if (field?.type === 'date' && field?.dateFormat) return formatCurrentDate(value, field?.dateFormat);
		if (field?.type === 'date') return formatCurrentDate(value, selectedDateFormat);
		if (Array.isArray(value)) return value.join(', ');
		if (typeof value === 'object') return Object.keys(value).length ? JSON.stringify(value) : fallback;

		return value;
	}

	const handleOptionChange = (selectedOption) => {
		setNewSection({ ...newSection, keyName: selectedOption.value });
	};

	const options = fieldsData?.map((option) => ({
		value: option?.keyName,
		label: option?.title,
	}));

	const handlePrintStatus = async (status, printed) => {
		const instance = getAxiosInstance();
		try {
			await instance.post('/college/transferCertificate/updatePrintedStatus', { _id: profile?._id, collegeId, printed: status?.target.checked || printed });
			toast.success('Updated Succesfully');
			setTcView(false);
			setProfile(null);
			refetchList();
		} catch (error) {
			toast.error('not saved');
			console.error('Error uploading file:', error);
		}
	};

	const ccData = [
		{
			keyName: 'name',
			title: 'Name of Student',
			longTitle: 'Name of Student',
			width: '200px',
			type: 'string',
			category: 'basicDetails',
		},
		{
			keyName: 'dob',
			title: 'Date of Birth',
			longTitle: 'Date of Birth',
			width: '120px',
			type: 'date',
			category: 'basicDetails',
		},
		{
			keyName: 'hallTicketNo',
			title: 'Register No',
			longTitle: 'Register No',
			width: '150px',
			type: 'string',
			category: 'academicDetails',
		},
		{
			keyName: 'longNameWithNothing',
			title: 'Degree & Branch',
			longTitle: 'Degree & Branch',
			width: '150px',
			type: 'string',
			category: 'basicDetails',
		},
		{
			keyName: 'batchName',
			title: 'Period of Study',
			longTitle: 'Degree & Branch',
			width: '150px',
			type: 'string',
			category: 'basicDetails',
		},
		{
			keyName: '',
			title: 'Medium of Language',
			longTitle: 'Degree & Branch',
			width: '150px',
			type: 'string',
			value: 'English',
			category: 'basicDetails',
		},

		{
			keyName: '',
			title: 'Status of Study',
			longTitle: 'Status of Study',
			width: '150px',
			type: 'string',
			value: 'Completed',
			category: 'basicDetails',
		},
	];
	const renderPage = () => (
		<div
			style={{
				padding: customStyles?.padding,
				marginRight: customStyles?.marginRight,
				width: customStyles?.width,
				height: customStyles?.height,
				fontFamily: customStyles?.fontFamily,
				zIndex: 1000,
				backgroundColor: 'white',
			}}
			className={` screen:shadow-lg relative  overflow-y-scroll  print:w-full print:h-full `}>
			<style>
				{`
	  .printable {
		box-sizing: border-box;
	  }
	  @media print {
		@page {
		  size: ${'legal'} ${'landscape'};
		  margin: 0;
		}
		.printable {
		  width: 100%
		  height: 98%
		  padding: ${customStyles?.padding};
		  margin: ${customStyles?.margin};
		}
	  }
	`}
			</style>
			<div style={{ marginTop: customStyles?.marginTop }}></div>
			{selectedFields?.headerLogo && <img src={logo} alt='Logo' style={{ position: 'absolute', top: customStyles?.top, left: customStyles?.left, width: customStyles?.logoSize, height: customStyles?.logoSize, zIndex: 2 }} className=' opacity-90' />}
			{selectedFields?.watermarkLogo && <img src={logo} alt='Logo' style={{ position: 'absolute', top: customStyles?.watermarkTop, left: customStyles?.watermarkLeft, width: customStyles?.watermarkSize, height: customStyles?.watermarkSize, opacity: customStyles?.watermarkOpacity, zIndex: 1 }} />}
			<div className='text-center mb-6 relative z-30'>
				{customHeaders?.map((head) => (
					<React.Fragment key={head.key}>
						{head.checked === true && (
							<p
								style={{
									fontSize: `${head?.style?.find((s) => s.key === 'fontSize')?.value}px`,
									lineHeight: `${head?.style?.find((s) => s.key === 'lineHeight')?.value}px`,
									fontWeight: head?.style?.find((s) => s.key === 'fontWeight')?.value || 'normal',
									textDecoration: head?.style?.find((s) => s.key === 'textDecoration')?.value || 'none',
									color: head?.style?.find((s) => s.key === 'color')?.value || 'none',
								}}
								className=''>
								{head?.value}
							</p>
						)}
					</React.Fragment>
				))}
			</div>

			<div style={{ fontSize: customStyles?.fontSize, gap: customStyles?.gap, zIndex: 1000, position: 'relative', paddingTop: '5px', marginRight: customStyles?.bodyAjustWidth, paddingRight: customStyles?.bodyAjustWidth, marginTop: customStyles?.bodyAjustVertical, left: customStyles?.bodyAjustHorizontal }}>
				<p className='font-semibold absolute ' style={customStyles?.tcPosition === 'top-left' ? { top: customStyles?.tcNoAdjustVertical, left: customStyles?.tcNoAdjustHorizontal } : customStyles?.tcPosition === 'top-right' ? { top: customStyles?.tcNoAdjustVertical, right: customStyles?.tcNoAdjustHorizontal } : customStyles?.tcPosition === 'bottom-left' ? { bottom: customStyles?.tcNoAdjustVertical, left: customStyles?.tcNoAdjustHorizontal } : { bottom: customStyles?.tcNoAdjustVertical, right: customStyles?.tcNoAdjustHorizontal }}>
					<span style={{ fontSize: customStyles?.tcNoFontSize, lineHeight: customStyles?.tcNoLineHeight, fontWeight: customStyles?.tcNoFontWeight }}>{tcNumberText ?? 'TC Number'}: </span>
					{customStyles?.tcBatchPosition === 'before' && (
						<span style={{ fontSize: customStyles?.tcNoFontSize, lineHeight: customStyles?.tcNoLineHeight, fontWeight: customStyles?.tcNoFontWeight }}>
							{profile?.tcBatchNumber}
							{customStyles?.tcBatchSeperation}
						</span>
					)}
					<span style={{ fontSize: customStyles?.tcNoFontSize, lineHeight: customStyles?.tcNoLineHeight, fontWeight: customStyles?.tcNoFontWeight }}>{profile?.tcNumber}</span>
					{customStyles?.tcBatchPosition === 'after' && (
						<span style={{ fontSize: customStyles?.tcNoFontSize, lineHeight: customStyles?.tcNoLineHeight, fontWeight: customStyles?.tcNoFontWeight }}>
							{customStyles?.tcBatchSeperation}
							{profile?.tcBatchNumber}
						</span>
					)}
					{customStyles?.tcBatchPosition === 'afterYear' && (
						<span style={{ fontSize: customStyles?.tcNoFontSize, lineHeight: customStyles?.tcNoLineHeight, fontWeight: customStyles?.tcNoFontWeight }}>
							{customStyles?.tcBatchSeperation}
							{new Date().getFullYear()}
						</span>
					)}
				</p>
				<p className='font-semibold absolute ' style={customStyles?.tcDatePosition === 'top-left' ? { top: customStyles?.tcDateAdjustVertical, left: customStyles?.tcDateAdjustHorizontal } : customStyles?.tcDatePosition === 'top-right' ? { top: customStyles?.tcDateAdjustVertical, right: customStyles?.tcDateAdjustHorizontal } : customStyles?.tcDatePosition === 'bottom-left' ? { bottom: customStyles?.tcDateAdjustVertical, left: customStyles?.tcDateAdjustHorizontal } : { bottom: customStyles?.tcDateAdjustVertical, right: customStyles?.tcDateAdjustHorizontal }}>
					<span style={{ fontSize: customStyles?.tcDateFontSize, lineHeight: customStyles?.tcDateLineHeight, fontWeight: customStyles?.tcDateFontWeight }}>Date: {profile[customTcDateKey] || customTcDateKey === 'now' ? formatCurrentDate(customTcDateKey === 'now' ? new Date() : profile[customTcDateKey] ?? profile?.tcDate, customStyles?.tcDateFormat) : <span style={{ fontSize: customStyles?.fontSize, fontWeight: 'lighter' }}>.............................</span>}</span>
				</p>
				{/* <div className='flex justify-between mb-2 ' style={{ gap: customStyles?.gap, fontSize: customStyles?.fontSize }}> */}
				{/* </div> */}
				{sections
					?.filter((field) => field && field?.checked)
					.map((field, index) => (
						<div key={field?.keyName} style={{ display: 'grid', gridTemplateColumns: '1fr 0 1fr', padding: '0', margin: '0', marginTop: customStyles?.lineHeight }}>
							<div className='flex items-start p-0 m-0'>
								<span className='pr-1 ' style={{ fontWeight: customStyles.bodyFieldFontWeight, fontSize: customStyles?.fontSize, lineHeight: customStyles?.paraLineHeight }}>
									{index + 1 + '.'}
								</span>
								<span className='' style={{ fontWeight: customStyles.bodyFieldFontWeight, fontSize: customStyles?.fontSize, lineHeight: customStyles?.paraLineHeight, ...(field?.titleFontWeight && { fontWeight: field.titleFontWeight }) }}>
									{field?.title}
								</span>
							</div>
							<p style={{ fontSize: customStyles?.fontSize, fontWeight: customStyles.bodyFieldFontWeight, lineHeight: customStyles?.paraLineHeight, alignSelf: 'baseline', marginTop: 'auto' }}>:</p>

							<p
								style={{
									fontSize: customStyles?.fontSize,
									fontWeight: customStyles.bodyValueFontWeight,
									lineHeight: customStyles?.paraLineHeight,
									paddingLeft: '14px',
									marginTop: 'auto',
									...(field?.valueFontWeight && { fontWeight: field.valueFontWeight }),
								}}>
								{safeFieldRender(field, profile, selectedDateFormat)}
							</p>
						</div>
					))}
			</div>

			{selectedFields?.signatureText && (
				<div className='text-right mt-2 absolute' style={customStyles?.principlePosition === 'top-left' ? { top: customStyles?.signatureTextVertical, left: customStyles?.signatureTextHorizontal } : customStyles?.principlePosition === 'top-right' ? { top: customStyles?.signatureTextVertical, right: customStyles?.signatureTextHorizontal } : customStyles?.principlePosition === 'bottom-left' ? { bottom: customStyles?.signatureTextVertical, left: customStyles?.signatureTextHorizontal } : { bottom: customStyles?.signatureTextVertical, right: customStyles?.signatureTextHorizontal }}>
					<div className='flex justify-end'>
						<p style={{ fontSize: customStyles?.fontSize, fontWeight: 'bold' }}>{signatureText}</p>
					</div>
				</div>
			)}

			{selectedFields?.signature && <img src={signature} alt='Signature' style={{ position: 'absolute', top: customStyles?.signTop, left: customStyles?.signLeft, width: customStyles?.signSize, height: '100%', zIndex: 2, objectFit: 'contain' }} />}

			{selectedFields?.seal && seal && <img src={seal} alt='Seal' style={{ position: 'absolute', top: customStyles?.sealTop, left: customStyles?.sealLeft, width: customStyles?.sealSize, height: '100%', zIndex: 2, objectFit: 'contain' }} />}
		</div>
	);

	return (
		<Main width='100vw' height='100vh' className='relative' title='Print Transfer Certificate'>
			<Toaster />
			<div className='flex gap-2 float-right items-center justify-end p-2'>
				<div className='relative flex items-center space-x-2 bg-slate-300 p-2 border border-gray-300 rounded'>
					<Switch checked={profile?.printed} onChange={(e) => handlePrintStatus(e)} />
					<label className='text-sm font-medium text-gray-700'>Is Already Printed</label>
				</div>
				{settings ? (
					<div className='flex'>
						<Button
							type='save'
							onClick={() => {
								saveSettings();
								setCopies(true);
							}}>
							Save Settings
						</Button>
						<Button
							type='close'
							onClick={() => {
								setCopies(true);
								setSettings(false);
							}}>
							Close Settings
						</Button>
					</div>
				) : (
					<div className='flex'>
						<Button
							type='save'
							onClick={() => {
								setCopies(false);
								setSettings(true);
							}}>
							Settings
						</Button>
						<div>
							<Button
								type='print'
								tableRef={ref.current}
								onClick={() => {
									console.log('print');
									handlePrintStatus({ target: { checked: true } });
									setCopies(true);
								}}
								className='text-xs font-semibold'>
								Print
							</Button>
						</div>
					</div>
				)}

				<Button type='pdf' onClick={() => handlePrintStatus({ target: { checked: true } })} tableRef={ref.current} className='text-xs font-semibold' pdfId='123' orientation={'l'}>
					PDF
				</Button>

				<Button type='close' onClick={() => setTcView(false)}>
					Close
				</Button>
			</div>
			<div className='p-0 flex justify-between h-full w-full overflow-x-scroll'>
				<div className='flex flex-col overflow-auto w-full h-full'>
					<section ref={ref} id='123' className={`grid ${settings ? 'grid-cols-1' : 'grid-cols-2'} place-items-center align-middle w-full h-full printable relative p-0 print:m-auto`}>
						{renderPage()}
						{customStyles?.pageBreak && (
							<div
								style={{
									position: 'absolute',
									left: '50%',
									width: '4px',
									alignSelf: 'center',
									height: '100%',
									borderLeft: '2px dotted black',
									borderStyle: 'solid',
									borderSpacing: '4px',
								}}></div>
						)}

						{copies && customStyles?.copies && renderPage()}
						{customStyles?.ccNeeded && (
							<div
								style={{
									padding: customStyles?.padding,
									margin: customStyles?.margin,
									width: customStyles?.width,
									height: customStyles?.height,
									fontFamily: customStyles?.fontFamily,
									zIndex: 1000,
									backgroundColor: 'white',
								}}
								className={` screen:shadow-lg relative  overflow-y-scroll  print:w-full print:h-full pt-6`}>
								<style>
									{`
							  .printable {
								box-sizing: border-box;
							  }
							  @media print {
								@page {
								  size: ${'legal'} ${'landscape'};
								  margin: 0;
								}
								.printable {
								  width: 100%
								  height: 98%
								  padding: ${customStyles?.padding};
								  margin: ${customStyles?.margin};
								  padding-top:'20px',
								}
							  }
							`}
								</style>
								<div style={{ marginTop: customStyles?.marginTop }}></div>
								{selectedFields?.headerLogo && <img src={logo} alt='Logo' style={{ position: 'absolute', top: customStyles?.top, left: customStyles?.left, width: customStyles?.logoSize, height: customStyles?.logoSize, zIndex: 2 }} className=' opacity-90' />}
								{selectedFields?.watermarkLogo && <img src={logo} alt='Logo' style={{ position: 'absolute', top: customStyles?.watermarkTop, left: customStyles?.watermarkLeft, width: customStyles?.watermarkSize, height: customStyles?.watermarkSize, opacity: customStyles?.watermarkOpacity, zIndex: 1 }} />}
								<div className='text-center mb-6 relative z-30'>
									{customHeaders?.slice(0, -1)?.map((head) => (
										<React.Fragment key={head.key}>
											{head.checked === true && (
												<p
													style={{
														fontSize: `${head?.style?.find((s) => s.key === 'fontSize')?.value}px`,
														lineHeight: `${head?.style?.find((s) => s.key === 'lineHeight')?.value}px`,
														fontWeight: head?.style?.find((s) => s.key === 'fontWeight')?.value || 'normal',
														textDecoration: head?.style?.find((s) => s.key === 'textDecoration')?.value || 'none',
														color: head?.style?.find((s) => s.key === 'color')?.value || 'none',
													}}
													className=''>
													{head?.value}
												</p>
											)}
										</React.Fragment>
									))}

									{customHeaders?.slice(-1)?.map((head) => (
										<React.Fragment key={head.key}>
											{head.checked === true && (
												<p
													style={{
														fontSize: `${head?.style?.find((s) => s.key === 'fontSize')?.value}px`,
														lineHeight: `${head?.style?.find((s) => s.key === 'lineHeight')?.value}px`,
														fontWeight: head?.style?.find((s) => s.key === 'fontWeight')?.value || 'normal',
														textDecoration: head?.style?.find((s) => s.key === 'textDecoration')?.value || 'none',
														color: head?.style?.find((s) => s.key === 'color')?.value || 'none',
													}}
													className=''>
													COURSE & CONDUCT CERTIFICATE
												</p>
											)}
										</React.Fragment>
									))}
								</div>

								<div style={{ fontSize: customStyles?.fontSize, gap: customStyles?.gap, zIndex: 1000, position: 'relative', paddingTop: '5px' }}>
									<div className='flex mb-6 '>
										<span className='w-full text-end'>Admn No : {profile?.admisionNo}</span>
									</div>
									<div className='grid'>
										<span className='mt-0 text-justify'>
											Certified that {profile?.name} Register Number: {profile.hallTicketNo} was bonafide student of this institution has completed the prescribed {profile?.batch} in {profile?.longNameWithNothing} full time (Regular Mode) in March {moment(profile?.dateOfLeaving || new Date()).format('YYYY')}. During the course period {profile?.gender === 'male' || profile?.gender === 'Male' ? 'His' : 'Her'} conduct and character was good.
										</span>
										<span className='mt-2'> The details of the student were duly verified with the records of this office and found to be genuine.</span>
									</div>

									{ccData?.map((field, index) => (
										<div key={field?.keyName} style={{ display: 'grid', gridTemplateColumns: '1fr 0 1fr', padding: '0', margin: '0', marginTop: customStyles?.lineHeight }}>
											<div className='flex items-start p-0 m-0'>
												<span className='pr-1 ' style={{ fontWeight: customStyles.bodyFieldFontWeight, fontSize: customStyles?.fontSize, lineHeight: customStyles?.paraLineHeight }}>
													{index + 1 + '.'}
												</span>
												<span className='' style={{ fontWeight: customStyles.bodyFieldFontWeight, fontSize: customStyles?.fontSize, lineHeight: customStyles?.paraLineHeight }}>
													{field?.title}
												</span>
											</div>
											<p style={{ fontSize: customStyles?.fontSize, fontWeight: customStyles.bodyFieldFontWeight, lineHeight: customStyles?.paraLineHeight, alignSelf: 'baseline', marginTop: 'auto' }}>:</p>
											<p
												style={{
													fontSize: customStyles?.fontSize,
													fontWeight: customStyles.bodyValueFontWeight,
													lineHeight: customStyles?.paraLineHeight,
													paddingLeft: '14px',
													marginTop: 'auto',
												}}>
												{safeFieldRender(field, profile, selectedDateFormat)}
											</p>
										</div>
									))}


									<div className="grid">
										{college?.area && (
											<>
												<span className="mt-10 font-medium text-[12px] block">{college.area}</span>
												<div className="mb-1" />
											</>
										)}
										<span
											className="font-bold block"
											style={{
												fontSize: customStyles?.fontSize,
												fontWeight: 'lighter',
												marginTop: college?.area ? 0 : '4rem',
											}}
										>
											{safeFieldRender({ keyName: 'tcIssueDate', type: 'date' }, profile, customStyles?.tcDateFormat, '')}
										</span>

									</div>






								</div>
								{selectedFields?.signatureText && (
									<div className='text-right mt-2 absolute' style={customStyles?.principlePosition === 'top-left' ? { top: customStyles?.signatureTextVertical, left: customStyles?.signatureTextHorizontal } : customStyles?.principlePosition === 'top-right' ? { top: customStyles?.signatureTextVertical, right: customStyles?.signatureTextHorizontal } : customStyles?.principlePosition === 'bottom-left' ? { bottom: customStyles?.signatureTextVertical, left: customStyles?.signatureTextHorizontal } : { bottom: customStyles?.signatureTextVertical, right: customStyles?.signatureTextHorizontal }}>
										<div className='flex justify-end'>
											<p style={{ fontSize: customStyles?.fontSize, fontWeight: 'bold' }}>{signatureText}</p>
										</div>
									</div>
								)}
								{selectedFields?.signature && <img src={signature} alt='Signature' style={{ position: 'absolute', top: customStyles?.signTop, left: customStyles?.signLeft, width: customStyles?.signSize, height: '100%', zIndex: 2, objectFit: 'contain' }} />}
								{selectedFields?.seal && seal && <img src={seal} alt='Seal' style={{ position: 'absolute', top: customStyles?.sealTop, left: customStyles?.sealLeft, width: customStyles?.sealSize, height: '100%', zIndex: 2, objectFit: 'contain' }} />}
							</div>
						)}
					</section>
				</div>
				{settings && (
					<section className='m-0 min-w-[60%] h-full overflow-y-scroll p-3  rounded-md w-[60%] shadow-md' style={theme == 'dark' ? { backgroundColor: '#1f2937' } : { backgroundColor: '#ffffff' }}>
						<div className='bg-gray-600 dark:bg-gray-800 text-white py-4 px-6 mb-8 shadow-md rounded-t-md'>
							<h2 className='text-2xl font-bold text-white'>Customize Transfer Certificate</h2>
						</div>

						<div className='grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 gap-2'>
							<div className='p-2 rounded-lg shadow flex flex-col justify-between bg-gray-100 dark:bg-gray-700'>
								<label className='block text-left text-sm mb-2 text-gray-800 dark:text-gray-200'>Upload Logo/Watermark:</label>
								<img src={logo ? logo : 'https://placehold.co/400x400'} alt='' className='contain w-[10vw] self-center' />
								<input type='file' name='headerLogo' onChange={handleLogoUpload} className='block w-full text-sm text-gray-800 dark:text-gray-200' />
								<div className='px-4 py-3 mt-1 rounded-lg shadow-md flex justify-between items-center bg-gray-200 dark:bg-gray-700'>
									<div>
										<span className='text-sm font-semibold text-gray-800 dark:text-gray-200'>Header: </span>
										<input type='checkbox' name='headerLogo' checked={selectedFields?.headerLogo} onChange={handleFieldChange} className='form-checkbox h-4 w-4 text-blue-600 rounded focus:ring-blue-500' />
									</div>
									<div>
										<span className='text-sm font-semibold text-gray-800 dark:text-gray-200'>Watermark: </span>
										<input type='checkbox' name='watermarkLogo' checked={selectedFields?.watermarkLogo} onChange={handleFieldChange} className='form-checkbox h-4 w-4 text-blue-600 rounded focus:ring-blue-500' />
									</div>
								</div>
							</div>
							<div className='p-2 rounded-lg shadow flex flex-col justify-between bg-gray-100 dark:bg-gray-700'>
								<label className='block text-left text-sm mb-2 text-gray-800 dark:text-gray-200'>Upload Seal:</label>
								<img src={seal ? seal : 'https://placehold.co/600x400'} alt='Seal' className='contain w-[10vw] self-center' />
								<input type='file' name='seal' onChange={handleSealUpload} className='block w-full text-sm text-gray-800 dark:text-gray-200' />
								<div className='px-4 py-3 rounded-lg shadow-md flex justify-between items-center bg-gray-200 dark:bg-gray-700'>
									<span className='text-sm font-semibold text-gray-800 dark:text-gray-200'>Needed: </span>
									<input type='checkbox' name='seal' checked={selectedFields?.seal} onChange={handleFieldChange} className='form-checkbox h-4 w-4 text-blue-600 rounded focus:ring-blue-500' />
								</div>
							</div>
							<div className='p-2 rounded-lg shadow flex flex-col justify-between bg-gray-100 dark:bg-gray-700'>
								<label className='block text-left text-sm mb-2 text-gray-800 dark:text-gray-200'>Upload Signature:</label>
								<img src={signature ? signature : 'https://placehold.co/600x400'} alt='Signature' className='contain w-[10vw] self-center' />
								<input type='file' name='signature' onChange={handleSignatureUpload} className='block w-full text-sm text-gray-800 dark:text-gray-200' />
								<div className='px-4 py-3 rounded-lg shadow-md flex justify-between items-center bg-gray-200 dark:bg-gray-700'>
									<span className='text-sm font-semibold text-gray-800 dark:text-gray-200'>Needed: </span>
									<input type='checkbox' name='signature' checked={selectedFields?.signature} onChange={handleFieldChange} className='form-checkbox h-4 w-4 text-blue-600 rounded focus:ring-blue-500' />
								</div>
							</div>
						</div>
						<div className='dark:bg-gray-800 p-2 rounded-lg shadow grid grid-cols-2 gap-2 mt-4'>
							<div className='rounded-md p-2 shadow-md bg-gray-100 dark:bg-gray-700'>
								<span className='font-semibold text-gray-800 dark:text-gray-200'>Logo</span>

								<div>
									<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Logo Size: {customStyles?.logoSize}</label>
									<input type='range' min='0' max='200' value={parseInt(customStyles?.logoSize, 10)} onChange={(e) => setCustomStyles({ ...customStyles, logoSize: `${e.target.value}px` })} className='w-full' />
								</div>
								<div>
									<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Logo Top: {customStyles?.top}</label>
									<input type='range' min='0' max='100' value={parseInt(customStyles?.top, 10)} onChange={(e) => setCustomStyles({ ...customStyles, top: `${e.target.value}px` })} className='w-full' />
								</div>
								<div>
									<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Logo Left: {customStyles?.left}</label>
									<input type='range' min='0' max='100' value={parseInt(customStyles?.left, 10)} onChange={(e) => setCustomStyles({ ...customStyles, left: `${e.target.value}px` })} className='w-full' />
								</div>
							</div>
							<div className='rounded-md p-2 shadow-md bg-gray-100 dark:bg-gray-700'>
								<span className='font-semibold text-gray-800 dark:text-gray-200'>WaterMark</span>
								<div>
									<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>WaterMark Size: {customStyles?.watermarkSize}</label>
									<input type='range' min='100' max='800' value={parseInt(customStyles?.watermarkSize, 10)} onChange={(e) => setCustomStyles({ ...customStyles, watermarkSize: `${e.target.value}px` })} className='w-full' />
								</div>
								<div>
									<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>WaterMark Top: {customStyles?.watermarkTop}</label>
									<input type='range' min='-100' max='100' value={parseInt(customStyles?.watermarkTop, 10)} onChange={(e) => setCustomStyles({ ...customStyles, watermarkTop: `${e.target.value}%` })} className='w-full' />
								</div>
								<div>
									<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>WaterMark Left: {customStyles?.watermarkLeft}</label>
									<input type='range' min='-100' max='100' value={parseInt(customStyles?.watermarkLeft, 10)} onChange={(e) => setCustomStyles({ ...customStyles, watermarkLeft: `${e.target.value}%` })} className='w-full' />
								</div>
								<div>
									<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>WaterMark Opacity: {customStyles?.watermarkOpacity}</label>
									<input type='range' min='0' max='1' step='0.1' value={parseFloat(customStyles?.watermarkOpacity, 0.1)} onChange={(e) => setCustomStyles({ ...customStyles, watermarkOpacity: `${e.target.value}` })} className='w-full' />
								</div>
							</div>
							<div className='rounded-md p-2 w-full bg-gray-100 dark:bg-gray-700'>
								<div className='flex justify-between items-center'>
									<span className='font-semibold text-gray-800 dark:text-gray-200'>Seal</span>

									<Input2
										type='drop'
										state={customStyles}
										setState={setCustomStyles}
										className='w-[10vw]'
										fieldName='position'
										returnKey='signPosition'
										valueShowKey='label'
										optionDisplay='label'
										didntShowKey
										optionKey='value'
										options={[
											{ value: 'top-left', label: 'Top Left' },
											{ value: 'top-right', label: 'Top Right' },
											{ value: 'bottom-left', label: 'Bottom Left' },
											{ value: 'bottom-right', label: 'Bottom Right' },
										]}
									/>
								</div>

								<div>
									<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Seal Size: {customStyles?.sealSize}</label>
									<input type='range' min='100' max='800' value={parseInt(customStyles?.sealSize, 10)} onChange={(e) => setCustomStyles({ ...customStyles, sealSize: `${e.target.value}px` })} className='w-full' />
								</div>
								<div>
									<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Seal Top: {customStyles?.sealTop}</label>
									<input type='range' min='-100' max='100' value={parseInt(customStyles?.sealTop, 10)} onChange={(e) => setCustomStyles({ ...customStyles, sealTop: `${e.target.value}%` })} className='w-full' />
								</div>
								<div>
									<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Seal Left: {customStyles?.sealLeft}</label>
									<input type='range' min='-100' max='100' value={parseInt(customStyles?.sealLeft, 10)} onChange={(e) => setCustomStyles({ ...customStyles, sealLeft: `${e.target.value}%` })} className='w-full' />
								</div>
							</div>
							<div className='rounded-md p-2 w-full bg-gray-100 dark:bg-gray-700'>
								<div className='flex justify-between items-center'>
									<span className='font-semibold text-gray-800 dark:text-gray-200'>Signature</span>

									<Input2
										type='drop'
										state={customStyles}
										setState={setCustomStyles}
										className='w-[10vw]'
										fieldName='position'
										returnKey='sealPosition'
										valueShowKey='label'
										optionDisplay='label'
										didntShowKey
										optionKey='value'
										options={[
											{ value: 'top-left', label: 'Top Left' },
											{ value: 'top-right', label: 'Top Right' },
											{ value: 'bottom-left', label: 'Bottom Left' },
											{ value: 'bottom-right', label: 'Bottom Right' },
										]}
									/>
								</div>

								<div>
									<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Signature Size: {customStyles?.signSize}</label>
									<input type='range' min='100' max='800' value={parseInt(customStyles?.signSize, 10)} onChange={(e) => setCustomStyles({ ...customStyles, signSize: `${e.target.value}px` })} className='w-full' />
								</div>
								<div>
									<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Signature Top: {customStyles?.signTop}</label>
									<input type='range' min='-100' max='100' value={parseInt(customStyles?.signTop, 10)} onChange={(e) => setCustomStyles({ ...customStyles, signTop: `${e.target.value}%` })} className='w-full' />
								</div>
								<div>
									<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Signature Left: {customStyles?.signLeft}</label>
									<input type='range' min='-100' max='100' value={parseInt(customStyles?.signLeft, 10)} onChange={(e) => setCustomStyles({ ...customStyles, signLeft: `${e.target.value}%` })} className='w-full' />
								</div>
							</div>
						</div>
						<div className='mt-6   p-6 rounded-lg shadow dark:bg-[#202020f5]'>
							<h3 className='text-lg font-semibold mb-4 dark:text-white'>Customize Header Layout</h3>
							<div className='mt-6 space-y-2'>
								<DragDropContext onDragEnd={handleDragEndHeader}>
									<Droppable droppableId='droppable'>
										{(provided) => (
											<div {...provided.droppableProps} ref={provided.innerRef}>
												{customHeaders.map((item, index) => (
													<Draggable key={item.key} draggableId={item.key} index={index}>
														{(provided) => (
															<div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className=' px-4 py-3 rounded-lg shadow-md flex justify-between items-center  transition-colors duration-200 my-1 dark:bg-gray-700'>
																<div className='flex justify-between items-center w-full dark:text-white '>
																	{editingKey === item.key ? (
																		<input
																			type='text'
																			value={item.value}
																			className=' rounded p-2 mr-2 w-full text-sm text-gray-700 dark:text-white dark:bg-gray-800'
																			placeholder='Enter new header title'
																			onChange={(e) => {
																				setCustomHeaders((prevHeaders) => prevHeaders.map((header, i) => (i === index ? { ...header, value: e.target.value } : header)));
																			}}
																			onKeyDown={(e) => {
																				if (e.key === 'Enter') {
																					setEditingKey(null);
																				}
																			}}
																		/>
																	) : (
																		<span className='text-sm font-semibold text-gray-700 hover:cursor-pointer dark:text-white' onClick={() => handleEdit(item.key, item.value)}>
																			{item.value ?? `Add ${item.key} details`}
																		</span>
																	)}
																	<span className='px-2 cursor-pointer dark:text-white' onClick={() => deleteHeaders(item.key)}>
																		<MdDelete />
																	</span>
																</div>

																<input type='checkbox' name='address' checked={item?.checked || false} onChange={() => setCustomHeaders((prevHeaders) => prevHeaders.map((header, i) => (i === index ? { ...header, checked: !header.checked } : header)))} className='form-checkbox h-4 w-4 text-blue-600  rounded focus:ring-blue-500 mt-3' />
															</div>
														)}
													</Draggable>
												))}
												{provided.placeholder}
											</div>
										)}
									</Droppable>
								</DragDropContext>
								<div className='mb-2'>
									{addHeader ? (
										<>
											<input type='text' value={newHeaderTitle} onChange={(e) => setNewHeaderTitle(e.target.value)} placeholder='Enter new header title' className='shadow rounded p-2 mr-2 w-full text-sm text-gray-700' />
											<div className='flex justify-around p-2'>
												<button onClick={addNewHeader} className='bg-blue-500 text-white px-2 py-2 rounded'>
													Add New Header
												</button>
												<button onClick={() => setAddHeader(false)} className='bg-red-400 text-white px-2 py-2 rounded'>
													Cancel
												</button>
											</div>
										</>
									) : (
										<div className='text-center'>
											<button onClick={() => setAddHeader(true)} className='flex items-center justify-center gap-1 w-fit px-4 py-1 rounded-md hover:bg-gray-300 text-gray-800 font-medium text-base transition duration-200 m-2 mx-auto'>
												Add
												<MdAddBox size={20} />
											</button>
										</div>
									)}
								</div>
							</div>
							<div className='grid grid-cols-2 gap-2'>
								{customHeaders?.map((header) => (
									<React.Fragment key={header.key}>
										<div className='rounded-md p-2 shadow-md bg-gray-100 dark:bg-gray-700'>
											<span className='font-semibold text-gray-800 dark:text-gray-200'>{header.value}</span>
											{headerStylesKeys?.map((ste, index) => {
												const st = header?.style?.find((s) => s.key === ste.key) || { key: ste.key, type: ste.type, value: '', title: '', label: '' };
												return (
													<div key={index} className='mt-2'>
														<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>
															{st?.title}: {st?.value}
														</label>
														{st?.key === 'color' && <input type='color' value={st?.value} onChange={(e) => handleStyleChange(header.key, st.key, e.target.value)} className='w-9 h-9 rounded' />}

														{st.key === 'fontWeight' ? (
															<input type='range' min='100' max='900' step='100' value={st?.value} onChange={(e) => handleStyleChange(header.key, st.key, parseInt(e.target.value, 10))} className='w-full' />
														) : st.key === 'textDecoration' ? (
															<select value={st?.value} onChange={(e) => handleStyleChange(header.key, st.key, e.target.value)} className='w-full p-2 rounded-md shadow-sm dark:bg-[#202020f5]'>
																<option value='none'>None</option>
																<option value='underline'>Underline</option>
																<option value='overline'>Overline</option>
																<option value='line-through'>Line-through</option>
															</select>
														) : st.key === 'color' ? (
															<input type='color' value={st?.value} onChange={(e) => handleStyleChange(header.key, st.key, e.target.value)} className='w-full rounded' />
														) : (
															<input type='range' min='0' max='100' value={st?.value} onChange={(e) => handleStyleChange(header.key, st.key, parseInt(e.target.value, 10))} className='w-full' />
														)}
													</div>
												);
											})}
										</div>
									</React.Fragment>
								))}
							</div>
						</div>
						<div className='mt-6  p-6 rounded-lg shadow dark:bg-[#202020f5]'>
							<div className='mt-6 space-y-4'>
								<div className='space-y-2'>
									<div className='  py-3 rounded-lg grid gap-2'>
										<div className='  px-4 py-3 rounded-lg shadow-md flex justify-between   transition-colors duration-200 flex-col'>
											<span className='font-semibold text-gray-800 dark:text-gray-200'>Tc Number & Batch</span>

											<div>
												<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Font Size: {customStyles?.tcNoFontSize}</label>
												<input type='range' min='8' max='36' value={parseInt(customStyles?.tcNoFontSize, 10)} onChange={(e) => setCustomStyles({ ...customStyles, tcNoFontSize: `${e.target.value}px` })} className='w-full' />
											</div>
											<div>
												<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Line Height: {customStyles?.tcNoLineHeight}</label>
												<input type='range' min='0' max='50' value={parseInt(customStyles?.tcNoLineHeight, 10)} onChange={(e) => setCustomStyles({ ...customStyles, tcNoLineHeight: `${e.target.value}px` })} className='w-full' />
											</div>
											<div>
												<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Font Weight: {customStyles?.tcNoFontWeight}</label>
												<input type='range' min='100' max='900' step='100' value={parseInt(customStyles?.tcNoFontWeight, 10)} onChange={(e) => setCustomStyles({ ...customStyles, tcNoFontWeight: `${e.target.value}` })} className='w-full' />
											</div>

											<div className='flex flex-row justify-between items-center w-full'>
												{tcNumberTextEdit ? (
													<input type='text' name='signatureText' value={tcNumberText} onChange={(e) => setTcNumberText(e.target.value)} onBlur={() => setTcNumberTextedit(false)} className=' rounded p-2 text-sm text-gray-700 w-[50%]' />
												) : (
													<span className='text-sm font-semibold text-gray-700' onClick={() => setTcNumberTextedit(true)}>
														{tcNumberText}
													</span>
												)}
												<Input2
													type='drop'
													state={customStyles}
													setState={setCustomStyles}
													className='w-[10vw]'
													fieldName='TC Batch Position'
													returnKey='tcBatchPosition'
													valueShowKey='label'
													optionDisplay='label'
													didntShowKey
													optionKey='value'
													options={[
														{ value: 'after', label: 'After TC Number' },
														{ value: 'before', label: 'Before TC Number' },
														{ value: 'afterYear', label: 'Current Year After TC Number' },
														{ value: 'none', label: 'None' },
													]}
												/>
												<Input2
													type='drop'
													state={customStyles}
													setState={setCustomStyles}
													className='w-[10vw]'
													fieldName='TC Batch Sepration'
													returnKey='tcBatchSeperation'
													valueShowKey='label'
													optionDisplay='label'
													didntShowKey
													optionKey='value'
													options={[
														{ value: ', ', label: 'Comma (,)' },
														{ value: ' ', label: 'Space ( )' },
														{ value: '/ ', label: 'Slash (/)' },
														{ value: ' - ', label: 'hiphen (-)' },
													]}
												/>
												<Input2
													type='drop'
													state={customStyles}
													setState={setCustomStyles}
													className='w-[10vw]'
													fieldName='position'
													returnKey='tcPosition'
													valueShowKey='label'
													optionDisplay='label'
													didntShowKey
													optionKey='value'
													options={[
														{ value: 'top-left', label: 'Top Left' },
														{ value: 'top-right', label: 'Top Right' },
														{ value: 'bottom-left', label: 'Bottom Left' },
														{ value: 'bottom-right', label: 'Bottom Right' },
													]}
												/>
											</div>
											<div className='flex flex-row justify-between items-center w-full'>
												<div className='w-[45%]'>
													<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>TC No Adjust Vertically: {customStyles?.tcNoAdjustVertical}</label>
													<input type='range' min='-50' max='50' value={parseInt(customStyles?.tcNoAdjustVertical, 10)} onChange={(e) => setCustomStyles({ ...customStyles, tcNoAdjustVertical: `${e.target.value}%` })} className='w-full' />
												</div>
												<div className='w-[45%]'>
													<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>TC No Adjust Horizontaly: {customStyles?.tcNoAdjustHorizontal}</label>
													<input type='range' min='-50' max='50' value={parseInt(customStyles?.tcNoAdjustHorizontal, 10)} onChange={(e) => setCustomStyles({ ...customStyles, tcNoAdjustHorizontal: `${e.target.value}%` })} className='w-full' />
												</div>
											</div>
										</div>
										<div className='  px-4 py-3 rounded-lg shadow-md flex justify-between items-center  transition-colors duration-200 flex-col'>
											<div className=' w-full'>
												<span className='font-semibold text-gray-800 dark:text-gray-200'>Tc Date</span>
												<div>
													<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Font Size: {customStyles?.tcDateFontSize}</label>
													<input type='range' min='8' max='36' value={parseInt(customStyles?.tcDateFontSize, 10)} onChange={(e) => setCustomStyles({ ...customStyles, tcDateFontSize: `${e.target.value}px` })} className='w-full' />
												</div>
												<div>
													<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Line Height: {customStyles?.tcNoLineHeight}</label>
													<input type='range' min='0' max='50' value={parseInt(customStyles?.tcDateLineHeight, 10)} onChange={(e) => setCustomStyles({ ...customStyles, tcDateLineHeight: `${e.target.value}px` })} className='w-full' />
												</div>
												<div>
													<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Font Weight: {customStyles?.tcNoFontWeight}</label>
													<input type='range' min='100' max='900' step='100' value={parseInt(customStyles?.tcDateFontWeight, 10)} onChange={(e) => setCustomStyles({ ...customStyles, tcDateFontWeight: `${e.target.value}` })} className='w-full' />
												</div>
											</div>
											<div className='flex flex-row justify-between items-center w-full'>
												<Input2 type='drop' state={customStyles} setState={setCustomStyles} className='w-[15vw]' fieldName='date format' returnKey='tcDateFormat' options={dateFormats} />
												<Input2 type='drop' state={customTcDateKey} setState={setCustomTcDateKey} className='w-[15vw]' fieldName='date key' valueShowKey='title' optionDisplay='title' didntShowKey optionKey='keyName' options={[...fieldsData.filter((x) => x.type == 'date'), { keyName: null, title: 'Custom', value: '...........' }]} />

												<Input2
													type='drop'
													state={customStyles}
													setState={setCustomStyles}
													className='w-[15vw]'
													fieldName='position'
													returnKey='tcDatePosition'
													valueShowKey='label'
													optionDisplay='label'
													didntShowKey
													optionKey='value'
													options={[
														{ value: 'top-left', label: 'Top Left' },
														{ value: 'top-right', label: 'Top Right' },
														{ value: 'bottom-left', label: 'Bottom Left' },
														{ value: 'bottom-right', label: 'Bottom Right' },
													]}
												/>
											</div>

											<div className='flex flex-row justify-between items-center w-full'>
												<div className='w-[45%]'>
													<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>TC Date Adjust Vertically: {customStyles?.tcDateAdjustVertical}</label>
													<input type='range' min='-50' max='50' value={parseInt(customStyles?.tcDateAdjustVertical, 10)} onChange={(e) => setCustomStyles({ ...customStyles, tcDateAdjustVertical: `${e.target.value}%` })} className='w-full' />
												</div>
												<div className='w-[45%]'>
													<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>TC Date Adjust Horizontaly: {customStyles?.tcDateAdjustHorizontal}</label>
													<input type='range' min='-50' max='50' value={parseInt(customStyles?.tcDateAdjustHorizontal, 10)} onChange={(e) => setCustomStyles({ ...customStyles, tcDateAdjustHorizontal: `${e.target.value}%` })} className='w-full' />
												</div>
											</div>
										</div>
										<div className='  px-4 py-3 rounded-lg shadow-md flex justify-between items-center  transition-colors duration-200 flex-col'>
											<div className='flex flex-row justify-between items-center w-full'>
												<div className=' px-4 py-3 flex justify-between items-center'>
													{signatureTextEdit || !signatureText ? (
														<input type='text' name='signatureText' value={signatureText} onChange={(e) => setSignatureText(e.target.value)} onBlur={() => setSignatureTextEdit(false)} className=' rounded p-2 text-sm text-gray-700 w-full dark:text-white dark:bg-black' />
													) : (
														<span className='text-sm font-semibold text-gray-700 dark:text-white' onClick={() => setSignatureTextEdit(true)}>
															{signatureText}
														</span>
													)}
													<input type='checkbox' name='signatureText' checked={selectedFields?.signatureText} onChange={handleFieldChange} className='form-checkbox h-4 w-4 text-blue-600 rounded focus:ring-blue-500 ml-3' />
												</div>{' '}
												<Input2
													type='drop'
													state={customStyles}
													setState={setCustomStyles}
													className='w-[15vw]'
													fieldName='position'
													returnKey='principlePosition'
													valueShowKey='label'
													optionDisplay='label'
													didntShowKey
													optionKey='value'
													options={[
														{ value: 'top-left', label: 'Top Left' },
														{ value: 'top-right', label: 'Top Right' },
														{ value: 'bottom-left', label: 'Bottom Left' },
														{ value: 'bottom-right', label: 'Bottom Right' },
													]}
												/>
											</div>

											<div className='flex flex-row justify-between items-center w-full'>
												<div className='w-[45%]'>
													<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Principal Adjust Vertically: {customStyles?.signatureTextVertical}</label>
													<input type='range' min='-50' max='50' value={parseInt(customStyles?.signatureTextVertical, 10)} onChange={(e) => setCustomStyles({ ...customStyles, signatureTextVertical: `${e.target.value}%` })} className='w-full' />
												</div>
												<div className='w-[45%]'>
													<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Principal Adjust Horizontaly: {customStyles?.signatureTextHorizontal}</label>
													<input type='range' min='-50' max='50' value={parseInt(customStyles?.signatureTextHorizontal, 10)} onChange={(e) => setCustomStyles({ ...customStyles, signatureTextHorizontal: `${e.target.value}%` })} className='w-full' />
												</div>
											</div>
										</div>
									</div>

									<DragDropContext onDragEnd={handleDragEnd}>
										<Droppable droppableId='droppable'>
											{(provided) => (
												<div {...provided.droppableProps} ref={provided.innerRef} className='mt-4 pt-1'>
													{sections?.map((field, index) => (
														<Draggable key={field?._id || `default-${index}`} draggableId={field?._id || `default-${index}`} index={index}>
															{(provided) => (
																<div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className='  px-4 py-3 my-1 rounded-lg shadow-md flex justify-between items-center dark:bg-gray-700 duration-200'>
																	<div className='flex flex-col w-full'>
																		<span className='text-sm font-semibold text-gray-700  cursor-pointer dark:text-white' onClick={(e) => handleTitleEdit(field)}>
																			{index + 1}, {field?.title || 'Default Title'}
																		</span>
																		<span className='text-sm  ml-6 text-gray-400  cursor-pointer' onClick={(e) => handleTitleEdit(field)}>
																			{field?.keyName || ''}
																		</span>
																	</div>

																	<div className='flex justify-between items-center gap-2 px-4 py-2  rounded-xl shadow-sm'>
																		<div className='flex items-center gap-3'>
																			<span className={`text-sm font-semibold cursor-pointer ${field.keyName ? 'text-green-600' : 'text-blue-600'}`}>{field.keyName ? 'Dynamic' : 'Static'}</span>

																			<button onClick={() => setEditingFieldKey(field)} className='p-1 rounded-full hover:bg-blue-100 transition duration-200 active:scale-95'>
																				<GrFormEdit size={22} className='text-blue-600' />
																			</button>

																			<button onClick={() => deleteSections(field)} className='p-1 rounded-full hover:bg-red-100 transition duration-200 active:scale-95'>
																				<MdDelete size={22} className='text-red-600' />
																			</button>
																			<input
																				type='checkbox'
																				name={field?._id || `default-${index}`}
																				checked={sections[index]?.checked ?? false}
																				onChange={() => {
																					setSections((prev) => prev.map((section, i) => (section._id === field?._id ? { ...section, checked: !section.checked } : section)));
																					// setSelectedFields((prev) => ({
																					// 	...prev,
																					// 	[field?.keyName]: !prev[field?.keyName],
																					// }));
																				}}
																				className='h-5 w-5 text-blue-600 rounded focus:ring-blue-500'
																			/>
																		</div>
																	</div>
																</div>
															)}
														</Draggable>
													))}
													{provided.placeholder}
												</div>
											)}
										</Droppable>
									</DragDropContext>

									<div className={`flex ${!addNew && !addCfield ? ' flex-row ' : 'flex-col'} justify-evently items-center`}>
										{addNew ? (
											<div className='mt-4 p-4   rounded-lg shadow'>
												<div className='grid grid-cols-2 gap-4'>
													<label className='block'>
														Key Name:
														<select name='keyName' value={newSection?.keyName} onChange={(e) => setNewSection({ ...newSection, keyName: e.target.value })} className=' rounded p-2 w-full'>
															<option value='' disabled>
																Select a key name
															</option>
															{fieldsData?.map((option) => (
																<option key={option?.keyName} value={option?.keyName}>
																	{option?.title}
																</option>
															))}
														</select>
													</label>
													<label className='block'>
														Data Type:
														<Select options={options} onChange={handleOptionChange} placeholder='Select a key name' isSearchable value={options.find((option) => option.value === newSection?.keyName)} />
													</label>

													<label className='block'>
														Title:
														<input type='text' name='title' value={newSection?.title} onChange={(e) => setNewSection({ ...newSection, title: e.target.value })} className=' rounded p-2 w-full' placeholder='Enter title' />
													</label>
													<label className='block'>
														Default value, if:
														<input type='text' name='title' value={newSection?.value} onChange={(e) => setNewSection({ ...newSection, value: e.target.value })} className=' rounded p-2 w-full' placeholder='Enter Value' />
													</label>
												</div>

												<div className='flex gap-4'>
													<button
														type='button'
														className='mt-4 bg-blue-500 text-white p-2 rounded hover:bg-blue-600'
														onClick={() => {
															setSections((prevSections) => [...prevSections, { ...newSection, value: '', _id: uuid4() }]);
															setNewSection({ keyName: '', title: '', longTitle: '', type: '' });
															setAddNew(false);
														}}>
														Add Field
													</button>
													<button
														type='button'
														className='mt-4 bg-red-500 text-white p-2 rounded hover:bg-red-600'
														onClick={() => {
															setNewSection({ keyName: '', title: '', longTitle: '', type: '', _id: uuid4() });
															setAddNew(false);
														}}>
														Cancel
													</button>
												</div>
											</div>
										) : (
											<div className='flex justify-center items-center'>
												<Button type='submit' onClick={() => setAddNew(true)} className='mt-4 bg-blue-500 text-white p-2 rounded hover:bg-blue-600'>
													Add Dynamic Field
												</Button>
											</div>
										)}

										{addCfield ? (
											<div>
												<label className='block'>
													Title:
													<input type='text' name='title' value={newCustomField?.title} onChange={(e) => setNewCustomField({ ...newCustomField, title: e.target.value })} className='border rounded p-2 w-full' placeholder='Enter title' />
												</label>
												<label className='block'>
													Value
													<input type='text' name='title' value={newCustomField?.value} onChange={(e) => setNewCustomField({ ...newCustomField, value: e.target.value })} className='border rounded p-2 w-full' placeholder='Enter Value' />
												</label>
												<div className='flex justify-center items-center gap-4'>
													<button
														type='button'
														className='mt-4 bg-blue-500 text-white p-2 rounded hover:bg-blue-600'
														onClick={() => {
															setSections((prevSections) => [...prevSections, { ...newCustomField, _id: uuid4() }]);
															// setCustomFields((prevSections) => [...prevSections, { ...newCustomField,_id: uuid4() }]);
															setNewCustomField({ keyName: '', title: '', longTitle: '', type: '' });
															setAddCField(false);
														}}>
														Add Custom Field
													</button>
													<button
														type='button'
														className='mt-4 bg-red-500 text-white p-2 rounded hover:bg-red-600'
														onClick={() => {
															setAddCField(false);
														}}>
														Cancel
													</button>
													{/* <Button type='submit' onClick={() => addCustomFields()} className='mt-4 bg-blue-500 text-white p-2 rounded hover:bg-blue-600'>
											Add Custom Field
										</Button> */}
												</div>
											</div>
										) : (
											<div className='flex justify-center items-center'>
												<Button type='submit' onClick={() => setAddCField(true)} className='mt-4 bg-blue-500 text-white p-2 rounded hover:bg-blue-600'>
													Add Custom Field
												</Button>
											</div>
										)}
									</div>
								</div>
							</div>
							<div className='mt-6   p-6 rounded-lg shadow'>
								<h3 className='text-lg font-semibold mb-2 mt-2 dark:text-white'>TC Content Layout</h3>
								<div className='grid grid-cols-2 gap-2'>
									<div>
										<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Body Adjust Vetically: {customStyles?.bodyAjustVertical}</label>
										<input type='range' min='-50' max='50' value={parseInt(customStyles?.bodyAjustVertical, 10)} onChange={(e) => setCustomStyles({ ...customStyles, bodyAjustVertical: `${e.target.value}px` })} className='w-full' />
									</div>
									<div>
										<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Body Adjust Horizontally: {customStyles?.bodyAjustHorizontal}</label>
										<input type='range' min='-50' max='50' value={parseInt(customStyles?.bodyAjustHorizontal, 10)} onChange={(e) => setCustomStyles({ ...customStyles, bodyAjustHorizontal: `${e.target.value}px` })} className='w-full' />
									</div>
									<div>
										<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Body Adjust Width: {customStyles?.bodyAjustWidth}</label>
										<input type='range' min='-50' max='50' value={parseInt(customStyles?.bodyAjustWidth, 10)} onChange={(e) => setCustomStyles({ ...customStyles, bodyAjustWidth: `${e.target.value}px` })} className='w-full' />
									</div>

									<div>
										<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Font Size: {customStyles?.fontSize}</label>
										<input type='range' min='8' max='36' value={parseInt(customStyles?.fontSize, 10)} onChange={(e) => setCustomStyles({ ...customStyles, fontSize: `${e.target.value}px` })} className='w-full' />
									</div>
									<div>
										<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Line Height: {customStyles?.lineHeight}</label>
										<input type='range' min='0' max='50' value={parseInt(customStyles?.lineHeight, 10)} onChange={(e) => setCustomStyles({ ...customStyles, lineHeight: `${e.target.value}px` })} className='w-full' />
									</div>
									<div>
										<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Pragraph Line Height: {customStyles?.paraLineHeight}</label>
										<input type='range' min='0' max='50' value={parseInt(customStyles?.paraLineHeight, 10)} onChange={(e) => setCustomStyles({ ...customStyles, paraLineHeight: `${e.target.value}px` })} className='w-full' />
									</div>
									<div>
										<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Title Font Weight: {customStyles?.bodyFieldFontWeight}</label>
										<input type='range' min='100' max='900' step='100' value={parseInt(customStyles?.bodyFieldFontWeight, 10)} onChange={(e) => setCustomStyles({ ...customStyles, bodyFieldFontWeight: `${e.target.value}` })} className='w-full' />
									</div>
									<div>
										<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Value Font Weight: {customStyles?.bodyValueFontWeight}</label>
										<input type='range' min='100' max='900' step='100' value={parseInt(customStyles?.bodyValueFontWeight, 10)} onChange={(e) => setCustomStyles({ ...customStyles, bodyValueFontWeight: `${e.target.value}` })} className='w-full' />
									</div>
									<div>
										<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Padding: {customStyles?.padding}</label>
										<input type='range' min='0' max='50' value={parseInt(customStyles?.padding, 10)} onChange={(e) => setCustomStyles({ ...customStyles, padding: `${e.target.value}px` })} className='w-full' />
									</div>
									<div>
										<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Margin Top: {customStyles?.marginTop}</label>
										<input type='range' min='0' max='50' value={parseInt(customStyles?.marginTop, 10)} onChange={(e) => setCustomStyles({ ...customStyles, marginTop: `${e.target.value}px` })} className='w-full' />
									</div>
								</div>
							</div>
							<div className='mt-6   p-6 rounded-lg shadow'>
								<h3 className='text-lg font-semibold mb-2 mt-2 dark:text-white'>TC Body Layout</h3>
								<div className='grid grid-cols-2 gap-2'>
									<div>
										<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Margin right: {customStyles?.marginRight}</label>
										<input type='range' min='0' max='50' value={parseInt(customStyles?.marginRight, 10)} onChange={(e) => setCustomStyles({ ...customStyles, marginRight: `${e.target.value}px` })} className='w-full' />
									</div>
									<div>
										<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Margin: {customStyles?.margin}</label>
										<input type='range' min='0' max='50' value={parseInt(customStyles?.margin, 10)} onChange={(e) => setCustomStyles({ ...customStyles, margin: `${e.target.value}px` })} className='w-full' />
									</div>
									<div>
										<div className='flex items-center space-x-3 p-2  dark:scheme-dark rounded-lg shadow-sm'>
											<label className='text-sm font-medium text-gray-700 pt-1 dark:text-white'>Extra Copy:</label>
											<div className='relative'>
												<input
													type='checkbox'
													checked={customStyles?.copies}
													onChange={(e) =>
														setCustomStyles((prevStyles) => ({
															...prevStyles,
															copies: e.target.checked,
														}))
													}
													className='h-5 w-5 border border-gray-300 rounded-md text-blue-600 focus:ring-2 focus:ring-blue-500 checked:bg-blue-600 checked:border-transparent transition-all duration-200'
												/>
											</div>
										</div>
									</div>
									<div>
										<div className='flex items-center space-x-3 p-2  dark:scheme-dark rounded-lg shadow-sm'>
											<label className='text-sm font-medium text-gray-700 pt-1 dark:text-white'>PageBreak:</label>
											<div className='relative'>
												<input
													type='checkbox'
													checked={customStyles?.pageBreak}
													onChange={(e) =>
														setCustomStyles((prevStyles) => ({
															...prevStyles,
															pageBreak: e.target.checked,
														}))
													}
													className='h-5 w-5 border border-gray-300 rounded-md text-blue-600 focus:ring-2 focus:ring-blue-500 checked:bg-blue-600 checked:border-transparent transition-all duration-200'
												/>
											</div>
										</div>
									</div>
									<div>
										<div className='flex items-center space-x-3 p-2  dark:scheme-dark rounded-lg shadow-sm'>
											<label className='text-sm font-medium text-gray-700 pt-1 dark:text-white'>CC :</label>
											<div className='relative'>
												<input
													type='checkbox'
													checked={customStyles?.ccNeeded}
													onChange={(e) =>
														setCustomStyles((prevStyles) => ({
															...prevStyles,
															ccNeeded: e.target.checked,
														}))
													}
													className='h-5 w-5 border border-gray-300 rounded-md text-blue-600 focus:ring-2 focus:ring-blue-500 checked:bg-blue-600 checked:border-transparent transition-all duration-200'
												/>
											</div>
										</div>
									</div>

									<div>
										<label className='text-sm font-medium text-gray-700 pt-1 dark:text-white'>Default Date Format:</label>
										<select value={selectedDateFormat} onChange={handleChange} className='w-full p-2 rounded-md dark:bg-[#202020f5]'>
											{dateFormats.map((format, index) => (
												<option key={index} value={format}>
													{formatCurrentDate(currentDate, format)}
												</option>
											))}
										</select>
									</div>
									<div>
										<label className='text-sm font-medium text-gray-700 pt-1 dark:text-white'>Font Family:</label>

										<select
											value={customStyles?.fontFamily || 'Times New Roman'}
											onChange={(e) =>
												setCustomStyles((prevStyles) => ({
													...prevStyles,
													fontFamily: e.target.value,
												}))
											}
											className='w-full p-2 rounded-md dark:bg-[#202020f5]'>
											<option value='Times New Roman'>Times New Roman</option>
											<option value='Arial'>Arial</option>
											<option value='Courier New'>Courier New</option>
											<option value='Georgia'>Georgia</option>
											<option value='Verdana'>Verdana</option>
											<option value='Sans-Serif'>Sans-Serif</option>
										</select>
									</div>
								</div>
							</div>
						</div>
					</section>
				)}
			</div>
			{editingFieldKey && (
				<Main zIndex='2000'>
					<div className='mt-4 p-4  rounded-lg shadow'>
						<div className='grid gap-4'>
							<div className='flex w-[30vw] justify-between'>
								<p style={editingFieldKey?.titleFontWeight && { fontWeight: editingFieldKey?.titleFontWeight }}>{editingFieldKey?.title}</p>:<p style={editingFieldKey?.valueFontWeight && { fontWeight: editingFieldKey?.valueFontWeight }}>{profile[editingFieldKey?.keyName]}</p>
							</div>
							<label className='block dark:text-white'>
								Key Name:
								<Select
									options={[{ label: 'Custom', value: 'custom' }, ...options]}
									onChange={(newVal) =>
										setEditingFieldKey((prev) => {
											const selectedOption = fieldsData?.find((option) => option.keyName === newVal.value);
											return {
												...prev,
												keyName: selectedOption?.keyName || '',
												type: selectedOption?.type || '',
												options: selectedOption?.options || null,
												stringType: selectedOption?.stringType || 'normal',
											};
										})
									}
									className='dark:text-black dark:bg-[#00000]'
									placeholder='Select a key name'
									isSearchable
									value={options.find((option) => option.value === editingFieldKey?.keyName) || { label: 'Custom', value: 'custom' }}
								/>
							</label>
							{/* )} */}
							{editingFieldKey?.type == 'date' && (
								<label className='block  dark:text-white'>
									Date Format: {formatCurrentDate(profile[editingFieldKey?.keyName], editingFieldKey?.dateFormat || selectedDateFormat)}
									<Select
										options={dateFormats.map((format) => ({
											label: formatCurrentDate(profile[editingFieldKey?.keyName], format),
											value: format,
										}))}
										className='dark:text-black dark:bg-[#00000]'
										onChange={(newVal) =>
											setEditingFieldKey((prev) => {
												return {
													...prev,
													dateFormat: newVal.value,
												};
											})
										}
										placeholder='Select a key name'
										isSearchable
										value={dateFormats
											.map((format) => ({
												label: formatCurrentDate(profile[editingFieldKey?.keyName], format),
												value: format,
											}))
											?.find((option) => option.value === editingFieldKey?.dateFormat)}
									/>
								</label>
							)}
							{editingFieldKey?.type === 'array' && <label className='block  dark:text-white'>Options: {editingFieldKey?.options?.map((x) => x.label)?.join(', ')}</label>}
							{editingFieldKey?.type !== 'date' && (
								<label className='block  dark:text-white'>
									Case:
									<Select
										options={[
											{ label: 'Upper Case'.toUpperCase(), value: 'upperCase' },
											{ label: 'Lower Case'.toLowerCase(), value: 'lowerCase' },
											{ label: 'Pascal Case', value: 'pascalCase' },
											{ label: 'Normal', value: 'normal' },
										]}
										className='dark:text-black dark:bg-[#00000]'
										onChange={(newVal) =>
											setEditingFieldKey((prev) => {
												return {
													...prev,
													stringType: newVal.value,
												};
											})
										}
										placeholder='Select Type'
										isSearchable
										value={
											editingFieldKey?.stringType && {
												value: editingFieldKey?.stringType,
												label: editingFieldKey?.stringType.charAt(0).toUpperCase() + editingFieldKey?.stringType.slice(1),
											}
										}
									/>
								</label>
							)}

							<label className='block  dark:text-white'>
								Title:
								<input
									type='text'
									value={editingFieldKey.title || ''}
									onChange={(e) =>
										setEditingFieldKey((prev) => ({
											...prev,
											title: e.target.value,
										}))
									}
									className=' rounded p-2 text-sm text-gray-700 w-full '
								/>
							</label>
							<label className='block  dark:text-white'>
								{editingFieldKey.keyName && 'Default'} Value:
								{!editingFieldKey?.options ? (
									<input
										type='text'
										value={editingFieldKey.value || ''}
										onChange={(e) =>
											setEditingFieldKey((prev) => ({
												...prev,
												value: e.target.value,
											}))
										}
										className=' rounded p-2 text-sm text-gray-700 w-full'
									/>
								) : (
									<Select
										options={editingFieldKey?.options}
										onChange={(newVal) =>
											setEditingFieldKey((prev) => ({
												...prev,
												value: newVal.label,
											}))
										}
										className='dark:text-black dark:bg-[#00000]'
										placeholder='Select a key name'
										isSearchable
										value={editingFieldKey?.options?.find((option) => option.value === editingFieldKey?.value)}
									/>
								)}
							</label>

							<div className=''>
								<h5>Styles</h5>
								<div>
									<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Title Font Weight: {editingFieldKey?.titleFontWeight}</label>
									<input type='range' min='100' max='900' step='100' value={parseInt(editingFieldKey?.titleFontWeight, 10)} onChange={(e) => setEditingFieldKey({ ...editingFieldKey, titleFontWeight: `${e.target.value}` })} className='w-full' />
								</div>
								<div>
									<label className='block text-sm mb-2 text-gray-800 dark:text-gray-200'>Value Font Weight: {editingFieldKey?.valueFontWeight}</label>
									<input type='range' min='100' max='900' step='100' value={parseInt(editingFieldKey?.valueFontWeight, 10)} onChange={(e) => setEditingFieldKey({ ...editingFieldKey, valueFontWeight: `${e.target.value}` })} className='w-full' />
								</div>
							</div>
						</div>

						<div className='flex gap-4'>
							<button
								type='button'
								className='mt-4 bg-blue-500 text-white p-2 rounded hover:bg-blue-600'
								onClick={() => {
									setSections((prevSections) => prevSections.map((section) => (section._id === editingFieldKey._id ? { ...section, ...editingFieldKey, checked: true } : section)));
									setEditingFieldKey(null);
								}}>
								Save Changes
							</button>
							<button type='button' className='mt-4 bg-red-500 text-white p-2 rounded hover:bg-red-600' onClick={() => setEditingFieldKey(null)}>
								Cancel
							</button>
						</div>
					</div>
				</Main>
			)}
		</Main>
	);
}

export default TCView2;